/* eslint-disable max-len */
export const osnForwardEmptyIcon = {
  data: `<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
  <mask id="mask0_20370_211086" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="40" y="29" width="19" height="19">
  <path d="M58.667 47.9948V29.3281H40.0003V47.9948H58.667Z" fill="currentColor"/>
  </mask>
  <g mask="url(#mask0_20370_211086)">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M57.4162 33.6962L50.469 44.9855C50.083 45.6126 49.2618 45.8082 48.6346 45.4222C48.4569 45.3128 48.3073 45.1632 48.1979 44.9855L41.2506 33.6962C40.8647 33.069 41.0602 32.2478 41.6874 31.8619C41.8975 31.7325 42.1394 31.6641 42.3862 31.6641H56.2807C57.0171 31.6641 57.614 32.261 57.614 32.9974C57.614 33.2441 57.5455 33.486 57.4162 33.6962Z" fill="currentColor"/>
  </g>
  <path d="M38.1021 50.7972C35.0952 52.4169 31.655 53.3359 28.0002 53.3359C16.2181 53.3359 6.66683 43.7847 6.66683 32.0026C6.66683 20.2205 16.2181 10.6693 28.0002 10.6693C39.7822 10.6693 49.3335 20.2205 49.3335 32.0026V32.6693" stroke="currentColor" stroke-width="4" stroke-linecap="round"/>
  </svg>
  `,
  name: 'forward-empty',
};
